import { render, staticRenderFns } from "./formBox.vue?vue&type=template&id=0562052b&scoped=true"
import script from "./formBox.vue?vue&type=script&lang=js"
export * from "./formBox.vue?vue&type=script&lang=js"
import style0 from "./formBox.vue?vue&type=style&index=0&id=0562052b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562052b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0562052b')) {
      api.createRecord('0562052b', component.options)
    } else {
      api.reload('0562052b', component.options)
    }
    module.hot.accept("./formBox.vue?vue&type=template&id=0562052b&scoped=true", function () {
      api.rerender('0562052b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/assess/config/components/formBox.vue"
export default component.exports